import {
    addWait,
    ajaxJSONWithoutError,
    ajaxJSONWithoutWait,
    busy,
    fieldValue,
    getFirstNotEmptyObj,
    isAnyEqualToFirst,
    isNotEmptyOrNull,
    isNullOrUndefined,
    namaCompare,
    nextId,
    removeWait,
    setFieldValue,
    substringBefore
} from "../common/NamaCommon";
import {BaseWidget} from "../widgets/BaseWidget";
import {findFieldMetadata} from "../common/Metadata";
import {columnEditor, columnTemplate, dataItemSetterCallback} from "./GridGetterAndSetterCallbacks";
import {translate, translateId, translateNaMaText, translateTitledId} from "../common/Translator";
import {
    fetchFilteringUIFor,
    fillFilterOperatorsForField,
    gridDataBoundForRowNumber,
    gridRowNumberColumn,
    namaTypeToKendoColumnType,
    startFilter,
    startGrouping,
    toNormalId
} from "../views/list/ListViewColumns";
import {gridSizeToPixels, isMobileDevice} from "../common/GUIUtilities";
import {userCanNOTCopyLine, userCanNOTInsertOrDeleteLine, userCanSearch, userCanViewField} from "../login/Security";
import * as ClientCache from "../login/ClientCache";
import {
    getCustomGUISettings,
    getGridPageSize,
    isFeatureEnabled,
    nextGUIDId,
    shouldShowHelpMsgs,
    shouldUseDetailedGridsInMobile,
    showFieldInfoFor
} from "../login/ClientCache";
import * as BaseDispatcher from "../actions/BaseDispatcher";
import {performPostAction} from "../actions/BaseDispatcher";
import {
    copyLinesAction,
    deleteRow,
    focusCell,
    goToNextRow,
    goToPreviousRow,
    gridFocusCell,
    onGridKeyDown,
    onGridKeyUp,
    openGridLineEditor,
    realLineKeys,
    showMultiCopyDialog
} from "../grid/GridEventsController";
import * as ApplicableWhen from '../constants/ApplicableWhen'
import * as GridAction from "../constants/GridAction";
import {isInNewMode} from '../views/edit/EditScreenToolbar'
import * as NamaURLS from "../constants/NamaURLS";
import {PopupQuickCreator} from "../views/edit/PopupQuickCreator";
import {bindClickOnSelectAll, fetchSelectorPopupPreferences, ReferenceSelectorPopup, updateCheckBoxes} from '../views/search/SearcherWindow'
import * as FieldType from "../constants/FieldType";
import * as types from "../constants/FieldType";
import {comboColumnEditor, comboTemplate} from "./GridCell_Combo";
import {calcReferenceEntityType, createQuickCreateContextInfo} from "../widgets/ReferenceWidget";
import {appendRow} from "./GridEventsController";
import {showTooltip} from "../common/TooltipUtil";
import {
    getColAggregates_,
    getColHidden,
    getColLocked,
    getColOrder,
    getColWidth,
    reorderColumns,
    setColAggregates_,
    setColHidden,
    setColLocked,
    setColWidth
} from "../views/StorageUtil";
import {shouldShowImage} from "../common/AttachmentLinkUtil";
import * as ShowImageIn from "../constants/ShowImageIn";
import {imgColumnTemplate} from "./GridCell_Reference";
import {toCSVLineWithSep} from "../common/StringUtils";
import {CustomItemSearcherWindow} from "../views/search/CustomItemSearcherWindow";
import {gridKey, NamaGridLineEditor} from "./NamaGridLineEditor";
import {QuestionFieldsEditor} from "../widgets/QuestionFieldsEditor";
import {defaultCriteriaForFilterField} from "../views/list/CriteriaFromFilterField";
import {QuestionListWidget} from "../widgets/QuestionListWidget";
import {findHelpMsgAndShowIt} from "../common/ErrorsNotification";

let unifiedRefWidth = "10em";

export function shouldApplyNewSearchUI(entityType) {
    return entityType === "InvItem" && getCustomGUISettings().itemLevels.length > 0;
}

function showNormalSelector(owner, entityType, callBack, contextInfo, inChangeDimsDialog, defaultCriteria, preferences) {
    new ReferenceSelectorPopup({
        owner: owner,
        entityType: entityType,
        refSelectedCallBack: callBack,
        contextInfo: contextInfo
        , inChangeDimsDialog: inChangeDimsDialog,
        defaultCriteria: defaultCriteria,
        preferences: preferences
    }).showPopup();
}

export function createSearcherWindow(owner, entityType, callBack, contextInfo, inChangeDimsDialog, defaultCriteria) {
    let newSearchUI = localStorage.getItem("newSearchUI");
    if (shouldApplyNewSearchUI(entityType) && isNotEmptyOrNull(newSearchUI)) {
        new CustomItemSearcherWindow({
            owner: owner,
            entityType: entityType,
            refSelectedCallBack: callBack,
            contextInfo: contextInfo
            , inChangeDimsDialog: inChangeDimsDialog,
            defaultCriteria: defaultCriteria
        }).showPopup();
        return;
    }
    if (owner._selectorPopupPreferences) {
        showNormalSelector(owner, entityType, callBack, contextInfo, inChangeDimsDialog, defaultCriteria, owner._selectorPopupPreferences);
        return;
    }
    fetchSelectorPopupPreferences(entityType, (preferences) => {
        owner._selectorPopupPreferences = preferences;
        showNormalSelector(owner, entityType, callBack, contextInfo, inChangeDimsDialog, defaultCriteria, preferences);
    });

}

function unifiedWidthInEM() {
    return unifiedRefWidth.substring(0, unifiedRefWidth.length - 2);
}

function isReferenceColumn(columnMetadata) {
    return columnMetadata.fieldType === FieldType.Genericreference || columnMetadata.fieldType === FieldType.Reference;
}

export function gridGroupFooterTemp(fieldID, suffix, owner) {
    return (data) => {
        let temp = "";
        let colAggregates_ = getColAggregates_(owner, fieldID);
        if (!colAggregates_)
            return temp;
        let modelId_ = modelId(fieldID);
        let aggrs = colAggregates_.split(",");
        if (!suffix)
            suffix = "";
        for (let aggr of aggrs) {
            if (!data[modelId_ + suffix])
                continue;
            temp += `, ${aggr}: ${data[modelId_ + suffix][aggr.toLowerCase()]} `;
        }
        temp = temp.substr(1, temp.length);
        return temp;
    }
}

function updateGridColumnsInOptions(grid, field, colAggregates) {
    if (!grid)
        return;
    let allColumns = grid.getOptions().columns.flatMap(c => c.columns ? c.columns : c);
    let col = allColumns.filter(c => c.field === field)[0];
    if (!colAggregates)
        col.aggregates = [];
    else
        col.aggregates = colAggregates;
}

function updateGroupingDataAndReGroup(grid, field, owner, colAggregates) {
    if (!grid || !field)
        return;
    let relatedField = null;
    let columnMetadata = findFieldMetadata(toNormalId(field), owner.metaData)
    if (columnMetadata.fieldType === FieldType.Genericreference || columnMetadata.fieldType === FieldType.Reference) {
        relatedField = field + "$code";
    }
    let groupingData = grid.dataSource.group();
    if (!groupingData)
        return;
    for (let gData of groupingData) {
        let aggregatesToAdd = gData.aggregates.filter(g => g.field !== field);
        if (relatedField)
            aggregatesToAdd = gData.aggregates.filter(g => g.field !== relatedField);
        if (colAggregates) {
            for (let aggr of colAggregates) {
                aggregatesToAdd.push({field: field, aggregate: aggr});
                if (relatedField)
                    aggregatesToAdd.push({field: relatedField, aggregate: aggr});
            }
        }
        gData.aggregates = aggregatesToAdd;
    }
    grid.dataSource.group(groupingData);
}

export function fetchColId(col) {
    let idOfGroupedCol = col.id;
    if (col.hidden && col.id.endsWith(".code"))
        idOfGroupedCol = substringBefore(col.id, ".code");
    return idOfGroupedCol;
}

export function resizeGroupHeadersWidthsIfNeeded(grid) {
    grid.lockedTable.find(".k-grouping-row").each(function (index) {
        let arrow = $(this).find("a");
        grid.tbody.find(".k-grouping-row:eq(" + index + ") td").text($(this).text());
        $(this).find("p").text(" ").append(arrow);
    });
    grid.lockedTable.find(".k-grouping-row").click(function () {
        if ($(this).find("a").hasClass("k-i-collapse"))
            grid.collapseGroup(this);
        else
            grid.expandGroup(this);
    });
}

function updateAggregatesStatus(field, container, owner) {
    let colAggregates_ = getColAggregates_(owner, toNormalId(field));
    if (colAggregates_) {
        let aggregates = colAggregates_.split(",");
        for (let aggr of aggregates) {
            container.find(".k-menu").find(`li>span:contains('${aggr}')`).addClass("k-state-selected");
        }
    }
}

function setColAggregates(selectedItem, field, container, owner, columns, suffix, grid) {
    let span = selectedItem.find("span");
    if (span.hasClass("k-state-selected"))
        span.removeClass("k-state-selected");
    else
        span.addClass("k-state-selected");
    let colAggregates = [];
    let selectedElems = selectedItem.parent().find("span.k-state-selected");
    for (let elem of selectedElems) {
        colAggregates.push($(elem).text())
    }
    setColAggregates_(owner, toNormalId(field), toCSVLineWithSep(",", colAggregates));
    updateAggregatesStatus(field, container, owner);
    colAggregates = colAggregates.map(aggr => aggr.toLowerCase());
    updateGridColumnsInOptions(grid, field, colAggregates);
    updateDataSrcAggregates(grid.columns, grid.dataSource, owner);
    updateGroupingDataAndReGroup(grid, field, owner, colAggregates);
}

function notAllowedAggregate(aggregate, fieldMetaData) {
    if (isAnyEqualToFirst(fieldMetaData.fieldType, FieldType.Reference, FieldType.Genericreference
        , FieldType.EntityType, FieldType.BigText, FieldType.Boolean, FieldType.Text, FieldType.Enum))
        return isAnyEqualToFirst(aggregate, "Min", "Max", "Average", "Sum");
    return false;
}

let aggregatesFunctions = ["Count", "Min", "Max", "Average", "Sum"];

export function colMenuBuilder(e, that, columns, gridInEditView, suffix, grid) {
    let field = e.field;
    let fieldMetaData = findFieldMetadata(toNormalId(e.field), that.metaData);
    fillFilterOperatorsForField(e.container.find("select:eq(0)"), fieldMetaData, that.owner.entityType);
    fillFilterOperatorsForField(e.container.find("select:eq(2)"), fieldMetaData, that.owner.entityType);
    let container = e.container;
    let menu = container.find(".k-menu").data("kendoMenu");
    let popup = container.data('kendoPopup');
    let aggregateItems = [];
    let aggregateFnsCopy = aggregatesFunctions;
    for (let aggregateFun of aggregateFnsCopy) {
        if (notAllowedAggregate(aggregateFun, fieldMetaData))
            continue;
        aggregateItems.push({text: aggregateFun});
    }
    menu.append({
        text: "Aggregates", cssClass: "aggregatesCol", spriteCssClass: "aggregatesColumn",
        items: aggregateItems
    });
    updateAggregatesStatus(field, container, that.owner);
    menu.bind("select", function (e) {
        let selectedItem = $(e.item);
        if (gridInEditView) {
            if (selectedItem.text() === "Lock")
                that.lockGridColumn(selectedItem, field);
            if (selectedItem.text() === "Unlock")
                that.unlockGridColumn(selectedItem, field);
        }
        if (aggregatesFunctions.contains(selectedItem.text()))
            setColAggregates(selectedItem, field, container, that.owner, columns, suffix, grid);
        if (selectedItem.text() === "Lock" || selectedItem.text() === "Unlock") {
            menu.close();
            popup.close();
        }
    });
    return menu;
}

export function updateDataSrcAggregates(columns, dataSource, owner) {
    let dsAggregate = [];
    let allColumns = columns.flatMap(c => c.columns ? c.columns : c);
    for (let col of allColumns) {
        let colAggregates_ = getColAggregates_(owner, col.id);
        if (!colAggregates_)
            continue;
        colAggregates_ = colAggregates_.split(",");
        for (let aggr of colAggregates_) {
            dsAggregate.push({field: col.field, aggregate: aggr.toLowerCase()});
        }
    }
    dataSource._aggregate = dsAggregate;
}

export function valueCalculatorForQuestionField(questionFieldEditor) {
    return (ref) => {
        let fields = questionFieldEditor.getQuestionFields().filter(field => field.id === ref);
        if (fields && fields.length)
            return fields[0].value;
        return "";
    };
}

/**
 * @implements FieldsOwner
 */
export class NamaGridWidget extends BaseWidget {
    get isField() {
        return false;
    }

    get isGridWidget() {
        return true;
    }

    getColumns() {
        return this.grid.columns;
    }

    rootElement() {
        let that = this;
        if (that.popupEditor)
            return that.popupEditor.rootElement();
        return that.findElement();
    }

    getFieldValue(fieldId) {

    }

    get entityType() {
        return this.owner.entityType;
    }

    /**
     *
     * @param {string} id
     * @param {namaTypes.EditScreenGrid} grid
     * @param {ExtendedNamaMetadata} metaData
     * @param  {FieldsOwner} owner
     */
    constructor({id, grid, metaData, owner, hasSelectBox}) {
        super({id, owner})
        this.metaData = metaData;
        this.id = id;
        this.grid = grid;
        this.elementId = nextId();
        this.owner = owner;
        this._firstRead = true;
        this.hasSelectBox = hasSelectBox;
    }

    createElement() {
        return $(`<div id="${this.elementId}" nid="${this.id}">`);
    }

    refCodeOrNameCol(columnId) {
        let that = this;
        if (!columnId.endsWith(".code") && !columnId.endsWith(".name"))
            return false;
        let refColId = columnId.substring(0, columnId.length - 5);
        let columnMetadata = findFieldMetadata(refColId, that.metaData);
        if (!columnMetadata)
            return false;
        if (columnMetadata.fieldType === FieldType.Genericreference || columnMetadata.fieldType === FieldType.Reference)
            return true;
        return false;
    }

    afterAttach() {
        let that = this;
        that.model = kendo.data.Model.define({id: "id"});
        /**
         * @type {kendo.ui.GridColumn[]}
         */
        let columns = [gridRowNumberColumn(that.owner)];
        let selectFieldId = "select";
        columns.push({
            id: selectFieldId,
            selectable: true,
            width: getFirstNotEmptyObj(getColWidth(that.owner, selectFieldId), 40),
            locked: true,
            hidden: !that.hasSelectBox,
            headerAttributes: {"class": "nama-selectAll-header"},
            order: getColOrder(that.owner, selectFieldId) || 2,
            attributes: {"class": "grid-check-box"}
        });
        let lastMergedColumn = {};

        let unifiedWidth = 100;
        let detailMetadata = findFieldMetadata(that.id, that.metaData)
        let i = columns.length + 1;
        for (let column of that.grid.columns) {
            let validId = "$" + column.id.replaceAll(".", "$");
            let columnMetadata = findFieldMetadata(column.id, that.metaData)
            let refColId = column.id.substring(0, column.id.length - 5);
            if (that.refCodeOrNameCol(column.id))
                columnMetadata = findFieldMetadata(refColId, that.metaData);
            let title = translateTitledId(that.owner.entityType, column);
            let columnTitle = title;
            let columnsToPushTo = columns;
            if (!columnMetadata)
                continue;
            if (!userCanViewField(that.owner.entityType, column.id))
                continue;
            if (!isFeatureEnabled(columnMetadata.relatedToFeature))
                continue;
            if (!isFeatureEnabled(columnMetadata.referencedEntityType))
                continue;
            let finalCalculatedWidth = column.width;
            if (column.width && isReferenceColumn(columnMetadata)) {
                let colWidth = parseInt(column.width.substring(0, column.width.length - 2));
                if (colWidth < unifiedWidthInEM())
                    finalCalculatedWidth = unifiedRefWidth;
            }
            if (title.contains("|")) {
                let mainHeader = null;
                [mainHeader, columnTitle] = title.split("|");

                if (mainHeader !== lastMergedColumn.title) {
                    lastMergedColumn = {
                        title: mainHeader,
                        id: refColId,
                        order: getColOrder(that.owner, refColId) || i,
                        headerAttributes: {"class": "nama-col-header"},
                        columns: []
                    }
                    columns.push(lastMergedColumn);
                }
                columnsToPushTo = lastMergedColumn.columns;
            }
            if (columnMetadata.fieldType === FieldType.Genericreference && !singleAllowedValuesForEntityTypes(columnMetadata)) {
                let colEntityTypeId = column.id + ".entityType";
                let entityTypeId = "$" + (colEntityTypeId.replaceAll(".", "$"));
                let refColId = column.id + ".ref";
                columnsToPushTo.push({
                    title: columnTitle,
                    order: getColOrder(that.owner, column.id) || i,
                    id: column.id,
                    locked: getColLocked(that.owner, column.id),
                    headerAttributes: {"class": "nama-col-header"},
                    columns: [{
                        id: colEntityTypeId,
                        field: entityTypeId,
                        title: "entityType",
                        type: "text",
                        hidden: isColHidden(that.owner, colEntityTypeId, column),
                        width: getFirstNotEmptyObj(getColWidth(that.owner, colEntityTypeId), "8em"),
                        headerTemplate: `<span id="${entityTypeId}" class="n-c-header">${translateId("entityType")}</span>`,
                        template: comboTemplate(columnMetadata.fieldId + ".entityType", getTrimmedId(columnMetadata, detailMetadata) + ".entityType"),
                        editor: comboColumnEditor(columnMetadata, getTrimmedId(columnMetadata, detailMetadata) + ".entityType", that, columnMetadata.fieldId + ".entityType"),
                        attributes: {"nama-col": entityTypeId, "fieldId": column.id},
                        headerAttributes: {"class": "nama-col-header"}
                    }, {
                        id: refColId,
                        field: validId,
                        title: columnTitle,
                        type: namaTypeToKendoColumnType(columnMetadata.fieldType),
                        hidden: isColHidden(that.owner, refColId, column),
                        width: getFirstNotEmptyObj(getColWidth(that.owner, refColId), finalCalculatedWidth, unifiedWidth),
                        headerTemplate: `<span id="${validId}" class="n-c-header">${columnTitle}</span>`,
                        template: columnTemplate(columnMetadata, getTrimmedId(columnMetadata, detailMetadata), that, column.id),
                        editor: columnEditor(columnMetadata, getTrimmedId(columnMetadata, detailMetadata), that, column.id),
                        attributes: {"nama-col": validId, "fieldId": column.id},
                        headerAttributes: {"class": "nama-col-header"}
                    }, that.codeColumn(column, unifiedWidth, columnTitle)]
                });
            } else if (columnMetadata.referencedEntityType && shouldShowImage(columnMetadata.referencedEntityType, ShowImageIn.GridSeparateColumn)) {
                columnsToPushTo.push({
                    title: columnTitle,
                    order: getColOrder(that.owner, column.id) || i,
                    locked: getColLocked(that.owner, column.id),
                    headerAttributes: {"class": "nama-col-header"},
                    columns: [{
                        field: validId,
                        id: column.id,
                        type: namaTypeToKendoColumnType(columnMetadata.fieldType),
                        width: getFirstNotEmptyObj(getColWidth(that.owner, column.id), finalCalculatedWidth, unifiedWidth),
                        hidden: isColHidden(that.owner, column.id, column),
                        headerTemplate: `<span id="${validId}" class="n-c-header">${columnTitle}</span>`,
                        template: columnTemplate(columnMetadata, getTrimmedId(columnMetadata, detailMetadata), that, column.id),
                        editor: columnEditor(columnMetadata, getTrimmedId(columnMetadata, detailMetadata), that, column.id),
                        attributes: {"nama-col": validId, "fieldId": column.id},
                        headerAttributes: {"class": "nama-col-header"}
                    }, {
                        width: unifiedWidth,
                        template: imgColumnTemplate(getTrimmedId(columnMetadata, detailMetadata)),
                        attributes: {"nama-col": validId, "class": "nama-col-header", "fieldId": column.id},
                    }, that.codeColumn(column, unifiedWidth, columnTitle)]
                })
            } else {
                columnsToPushTo.push({
                    id: column.id,
                    order: getColOrder(that.owner, column.id) || i,
                    locked: getColLocked(that.owner, column.id),
                    field: validId,
                    title: columnTitle,
                    type: namaTypeToKendoColumnType(columnMetadata.fieldType),
                    width: getFirstNotEmptyObj(getColWidth(that.owner, column.id), finalCalculatedWidth, unifiedWidth),
                    hidden: isColHidden(that.owner, column.id, column),
                    headerTemplate: `<span id="${validId}" class="n-c-header">${columnTitle}</span>`,
                    template: columnTemplate(columnMetadata, getTrimmedId(columnMetadata, detailMetadata), that, column.id),
                    editor: columnEditor(columnMetadata, getTrimmedId(columnMetadata, detailMetadata), that, column.id),
                    attributes: {"nama-col": validId, "fieldId": column.id},
                    headerAttributes: {"class": "nama-col-header"}
                });
                if (columnMetadata.fieldType === FieldType.Reference || columnMetadata.fieldType === FieldType.Genericreference)
                    columnsToPushTo.push(that.codeColumn(column, unifiedWidth, columnTitle));
                if (columnMetadata.fieldType === FieldType.Decimal || columnMetadata.fieldType === FieldType.Integer || columnMetadata.fieldType === FieldType.Long)
                    columnsToPushTo.push(that.numberColumn(column, unifiedWidth, columnTitle));
            }
            i++;
        }
        that.dataSource = new kendo.data.DataSource({
            transport: {
                read: (options) => {
                    that._readRows(options);
                },
                update: (options) => {
                    that.owner.setFieldValue(that.id, options.data.models);
                    that._readRows(options);
                },
                create: (options) => {
                    nextGUIDId().then((id) => {
                        options.success({id})
                    }).catch((e) => options.error(e));
                },
                destroy: (options) => {
                    that._readRows(options);
                }
            },
            // autoSync: true,
            pageSize: getGridPageSize(),
            schema: {
                model: that.constructModel(columns),
                parse: function (data) {
                    for (let i = 0; i < data.length; i++) {
                        that.setDataItemValues(data[i], i);
                    }
                    return data;
                }
            },
        });
        bindClickOnSelectAll(that.findElement());
        that.findElement().on("click", "#addNewLine", (e) => {
            that.addLine(e);
        });
        that.findElement().on("click", "#copyLine", (e) => {
            that.copyLine(e);
        });
        that.findElement().on("click", "#deleteLine", (e) => {
            that.deleteLine(e);
        });
        that.findElement().on("click", "#insertLine", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let grid = that._kendoGrid();
            appendRow(grid, false, that);
        });

        that.findElement().on("click", "#rowDown", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let grid = that._kendoGrid();
            goToNextRow(e, grid, that, true);
        });
        that.findElement().on("click", "#rowUp", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let grid = that._kendoGrid();
            goToPreviousRow(that, e, grid, true);
        });
        that.findElement().on("click", "#editLine", (e) => {
            openGridLineEditor(that, e);

        });
        that.findElement().on("click", "#selectLines", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let grid = that._kendoGrid();
            let gridColumns = grid.columns.filter(c => c.id === "select");
            if (!gridColumns || !gridColumns.length)
                return;
            let col = gridColumns[0];
            if (col.hidden) {
                $(e.target).addClass("k-state-active");
                grid.showColumn(grid.columns.indexOf(col));
            } else {
                $(e.target).removeClass("k-state-active");
                grid.hideColumn(grid.columns.indexOf(col));
                updateCheckBoxes(false, that.findElement());
            }
        });
        that.findElement().on("click", "#multiCopy", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let grid = that._kendoGrid();
            showMultiCopyDialog(grid, that);
        });
        that.findElement().on("click", ".column-search-btn", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let entityType = e.target.attributes.fieldEntityType.value;
            let columnId = e.target.attributes.columnId.value;
            if (that.closedCellOrGrid(columnId))
                return;
            if (!userCanSearch(entityType))
                return;
            createSearcherWindow(that, that.calcGenericRefEntityType(e, entityType), (record) => {
                that.refSelectionCallBack(columnId, record);
            }, BaseDispatcher.createSearchContextInfo(columnId, -1, this));
        });
        that.findElement().on("contextmenu", (e) => {
            that.showCellFieldInfo(e);
        });
        that.findElement().on("click", ".column-go-to-button", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let href = e.target.attributes.href.value;
            let fieldEntityType = e.target.attributes.fieldEntityType.value;
            let columnId = e.target.attributes.columnId.value;
            let current = that._kendoGrid().current();
            if (href && href.length) {
                if (!ClientCache.isOpenInPopup(columnId, that.owner.entityType)) {
                    window.open(href, "_blank");
                } else {
                    let id = e.target.attributes.refid.value;
                    ajaxJSONWithoutError(NamaURLS.FIND_BY_ID, {
                        id: id, entityType: fieldEntityType,
                        contextInfo: null
                    }, (ref) => {
                        new PopupQuickCreator(ref.data, null, null, that.owner.entityType, "", e).show();
                    });
                }
            } else {
                if (that.closedCellOrGrid(columnId))
                    return;
                let dataItem = that.currentDataItem();
                let rowIndex = that._getRowIndex();
                let columnMetadata = findFieldMetadata(columnId, that.metaData);
                /**
                 *
                 * @type {namaTypes.FieldActionContextInfo}
                 */
                let contextInfo = createQuickCreateContextInfo(that.owner.entityType, columnMetadata, columnId, rowIndex, that.owner);
                ajaxJSONWithoutWait(NamaURLS.CREATE_NEW, {
                    entityType: that.calcGenericRefEntityType(e, fieldEntityType)
                    , quickCreatorContextInfo: JSON.stringify(contextInfo)
                }, (result) => {
                    let newRecord = result.data;
                    new PopupQuickCreator(newRecord, contextInfo, (record) => {
                        that.updateInDataItem(dataItem, columnId, record);
                    }, null, null, e).show();
                });
            }
        });
        columns.sort((o1, o2) => namaCompare(o1.order, o2.order));
        columns.push({
            command: [{
                name: "addLine",
                text: "",
                click: (e) => that.addLine(e),
                iconClass: "k-icon k-i-add"
            }, {
                name: "copyLine",
                text: "",
                click: (e) => that.copyLine(e),
                iconClass: "k-icon k-i-copy"
            },
                {
                    name: "deleteLine",
                    text: "",
                    click: (e) => that.deleteLine(e),
                    iconClass: "k-icon k-i-delete"
                },
                {
                    name: "editCurrLine",
                    text: "",
                    click: (e) => openGridLineEditor(that, e),
                    iconClass: "k-icon k-i-edit"
                }],
            width: "180px"
        });
        let allColumns = columns.flatMap(c => c.columns ? c.columns : c);
        for (let col of allColumns) {
            let columnMetadata = findFieldMetadata(col.id, that.metaData);
            if (!columnMetadata)
                continue;
            if (shouldShowHelpMsgs()) {
                let headerTemplate = $(`<div><div><span id="${modelId(col.id)}" class="n-c-header">${col.title}<a href="#" title="${translateId("help")}" id="helpLink" class="k-icon k-i-help gridHelpLink">
                </a></span></div></div>`);
                col.headerTemplate = headerTemplate.html();
            }
            let colType = namaTypeToKendoColumnType(columnMetadata.fieldType);
            col.filterable = {
                ui: fetchFilteringUIFor(columnMetadata, that.owner.entityType),
                extra: colType === "boolean" ? false : true,
            };
            let idOfGroupedCol = fetchColId(col);
            col.groupFooterTemplate = gridGroupFooterTemp(idOfGroupedCol, "", that.owner);
            col.footerTemplate = gridGroupFooterTemp(idOfGroupedCol, "", that.owner);
            let colAggregates_ = getColAggregates_(that.owner, idOfGroupedCol);
            if (!colAggregates_) {
                col.aggregates = [];
            } else {
                let aggregates = colAggregates_.split(",");
                col.aggregates = aggregates.map(a => a.toLowerCase());
            }
        }
        that.findElement().kendoGrid({
            dataSource: that.dataSource,
            columns: columns,
            height: gridSizeToPixels(that.grid.gridSize),
            // sortable: true,
            pageable: {
                position: "top",
                refresh: true,
                pageSizes: [25, 50, 75, 100, "all"],
                buttonCount: 5
            },
            editable: {
                confirmation: false
            },
            navigatable: true,
            reorderable: !isMobileDevice(),
            filterable: true,
            filter: function (e) {
                startFilter(e, that.owner, "");
            },
            group: function (e) {
                startGrouping(e, that.owner, "");
            },
            autoBind: true,
            groupable: {
                messages: {empty: that.calcGridTitle()}
            },
            resizable: true,
            columnMenu: true,
            allowCopy: true,
            width: "100%",
            dataBound: function () {
                gridDataBoundForRowNumber(that._kendoGrid());
                that._fixWidthsAccordingToHeader();
                that.attachShortCutIcons();
                that._kendoGrid().resize();
                resizeGroupHeadersWidthsIfNeeded(that._kendoGrid());
            },
            edit: function (e) {
                let readonlyCell = e.container.attr("readonly");
                let readonlyGrid = e.container.closest(".k-grid").attr("readonlyGrid");
                let typedKeys = e.container.attr("typedKeys");
                if (that.popupEditor || readonlyCell || readonlyGrid) {
                    this.closeCell();
                } else {
                    setTimeout(function () {
                        let input = e.container.find("input");
                        if (typedKeys)
                            input.val(typedKeys);
                        else
                            input.select();
                        e.preventDefault();
                    }, 25);
                }
            },
            cancel: function (e) {
                let curCell = that.findElement().find(".k-state-focused").closest("td");
                curCell.removeAttr("typedKeys");
            },
            columnResize: function (e) {
                setColWidth(that.owner, e);
            },
            columnLock: function (e) {
                setColLocked(that.owner, e, true);
            },
            columnUnlock: function (e) {
                setColLocked(that.owner, e, false);
            },
            columnShow: function (e) {
                setColHidden(that.owner, e, false);
            },
            columnHide: function (e) {
                setColHidden(that.owner, e, true);
            },
            columnReorder: function (e) {
                reorderColumns(that.owner, that.findElement().data("kendoGrid"));
            },
            columnMenuInit: function (e) {
                let field = e.field;
                let menu = colMenuBuilder(e, that, columns, true, "", that.findElement().data("kendoGrid"));
                let singleColumn = columns.filter(c => c.field === field).length > 0;
                let hasNestedColumns = columns.filter(c => c.columns && c.columns.length > 0).length > 0;
                if (!field || !singleColumn || !hasNestedColumns)
                    return;
                menu.append({text: "Lock", cssClass: "lockCol", spriteCssClass: "lockColumn"});
                menu.append({text: "Unlock", cssClass: "unlockCol", spriteCssClass: "unlockColumn"});
            },
            navigate: function (e) {
                that.navigateEditorToCurrent();
            },
            mobile: isMobileDevice(),
            beforeEdit: function (e) {
                if (that.popupEditor)
                    e.preventDefault();
            },
        });
        that.findElement().on("click", "#helpLink", (e) => {
            e.preventDefault();
            let modelId = $(e.target).parent().attr("id");
            /**
             *
             * @type {namaTypes.DTOHelpMessagesRequest}
             */
            let reqData = {
                fieldId: toNormalId(modelId),
                entityType: that.entityType
            };
            findHelpMsgAndShowIt(reqData);
        });
        that.findElement().on("click", "#autoFitAllColumns", (e) => {
            e.preventDefault();
            that._autoFitColumns(true)
        });
        that.findElement().on("keyup", "table", function (e) {
            e.preventDefault();
            e.stopPropagation();
            onGridKeyUp(e, that);
        });
        that.findElement().on("keydown", "table", function (e) {
            onGridKeyDown(e, that);
        });
        that.findElement().on("dblclick", "td:has(.row-number)", (e) => {
            let currentRowIndex = that._kendoGrid().current().parent().index();
            showTooltip(that.owner.entityType, that.id, currentRowIndex, that.owner, that.id);
        });
    }

    constructModel(columns) {
        let that = this;
        let gridFields = {};
        columns.flatMap(c => c.columns ? c.columns : c).filter(c => {
            if (c.field && c.field.length)
                gridFields[c.field] = {type: that.calcFieldType(c)};
        });
        that.model = kendo.data.Model.define({id: "id", fields: gridFields});
        return that.model;
    }

    calcFieldType(col) {
        let that = this;
        let columnMetadata = findFieldMetadata(col.id, that.metaData);
        if (!columnMetadata)
            return "string";
        let type = columnMetadata.fieldType;
        if (type == FieldType.Decimal || type == FieldType.Integer || type == FieldType.Long)
            return "number";
        if (type == FieldType.Boolean)
            return "boolean";
        if (type == FieldType.Date || type == FieldType.Time || type == FieldType.DateAndTime)
            return "date";
        if (type == FieldType.Genericreference || type == FieldType.Reference)
            return "object";
        return "string";
    }

    async refSelectionCallBack(columnId, record) {
        let that = this;
        that.settingRef = true;
        let dataItem = that.currentDataItem();
        that.updateInDataItem(dataItem, columnId, record);
    }

    codeColumn(column, unifiedWidth, columnTitle) {
        return {
            field: "$" + ((column.id + ".code").replaceAll(".", "$")),
            id: column.id,
            hidden: true,
            title: columnTitle,
            menu: false
        };
    }

    numberColumn(column, unifiedWidth, columnTitle) {
        return {
            field: "$" + ((column.id + ".unformatted").replaceAll(".", "$")),
            id: column.id,
            hidden: true,
            title: columnTitle,
            menu: false
        };
    }

    calcGridTitle() {
        let that = this;
        return that.grid.title ? translateNaMaText(that.grid.title) : translate(that.grid.fieldId, that.owner.entityType);
    }

    navigateEditorToCurrent() {
        let that = this;
        if (!that.popupEditor)
            return;
        let grid = that._kendoGrid();
        let current = grid.current();
        let dataItem = grid.dataItem(current.parent());
        let rowIndex = current.parent().index();
        if (that.popupEditor.lineId !== dataItem.id)
            that.popupEditor.show(grid.dataItem(current.parent()), rowIndex);
    }

    lockGridColumn(selectedItem, field) {
        let that = this;
        selectedItem.addClass("k-state-disabled");
        selectedItem.parent().find(".unlockCol").removeClass("k-state-disabled");
        that.findElement().data("kendoGrid").lockColumn(field);
        let gridColumns = that._kendoGrid().columns.filter(c => c.field == field);
        if (!gridColumns)
            return;
        for (let col of gridColumns) {
            let width = col.width;
            if (typeof width == "string" && width.endsWith("em"))
                width = parseInt(substringBefore(width, "em")) * 16;
            that._kendoGrid().resizeColumn(col, width);
        }
    }

    unlockGridColumn(selectedItem, field) {
        let that = this;
        selectedItem.addClass("k-state-disabled");
        selectedItem.parent().find(".lockCol").removeClass("k-state-disabled");
        that.findElement().data("kendoGrid").unlockColumn(field);
    }

    addLine(e) {
        e.preventDefault();
        e.stopPropagation();
        let that = this;
        let grid = that._kendoGrid();
        appendRow(grid, true, that);
    }

    deleteLine(e) {
        e.preventDefault();
        e.stopPropagation();
        let that = this;
        let grid = that._kendoGrid();
        deleteRow(e, grid, that);
    }

    moreThanOneRowIsSelected() {
        return this._kendoGrid().table.find("tr.k-state-selected").length > 0;
    }

    copyLine(e) {
        e.preventDefault();
        e.stopPropagation();
        let that = this;
        let grid = that._kendoGrid();
        copyLinesAction(grid, that, 1);
    }

    showCellFieldInfo(e) {
        let that = this;
        let attributes = e.target.attributes;
        if (!attributes.fieldId)
            return;
        let columnId = attributes.fieldId.value;
        let columnMetadata = findFieldMetadata(columnId, that.metaData);
        let refTable = "";
        if (columnMetadata)
            refTable = columnMetadata.fieldType === FieldType.Genericreference ? toCSVLineWithSep(",", columnMetadata.allowedValues)
                : columnMetadata.referencedEntityType;
        showFieldInfoFor(that.entityType, columnId, refTable, e, that);
    }

    closedCellOrGrid(columnId) {
        let that = this;
        if (that.popupEditor)
            return true;
        let current = that._kendoGrid().current();
        let grid = that._kendoGrid();
        let dataItem = grid.dataItem(current.parent());
        let rowIndex = that._getRowIndex(dataItem.id);
        let cell = that.fetchCell(rowIndex, columnId);
        let readOnlyCell = cell.attr("readonly") === "true" || cell.attr("readonly") === "readonly";
        let readOnlyGrid = cell.closest(".k-grid").attr("readonlyGrid") === "true";
        return readOnlyCell || readOnlyGrid;
    }

    calcGenericRefEntityType(e, currentEntityType) {
        let that = this;
        let columnId = e.target.attributes.columnId.value;
        let columnMetadata = findFieldMetadata(columnId, that.metaData);
        if (!columnMetadata || columnMetadata.fieldType !== FieldType.Genericreference)
            return currentEntityType;
        let current = that._kendoGrid().current();
        let grid = that._kendoGrid();
        let dataItem = grid.dataItem(current.parent());
        currentEntityType = dataItem[modelId(columnId + ".entityType")];
        return calcReferenceEntityType(currentEntityType, columnMetadata);
    }

    async _readRows(options) {
        let that = this;
        let rows = that.owner.getFieldValue(that.id);
        if (isNullOrUndefined(rows)) {
            rows = [];
            that.owner.setFieldValue(that.id, rows);
        }
        if (!rows.length)
            rows.push({id: await nextGUIDId()});
        updateDataSrcAggregates(that._kendoGrid().columns, that._kendoGrid().dataSource, that.owner);
        options.success(rows);
        if (that._firstRead) {
            that._firstRead = false;
            gridFocusCell(that, that._kendoGrid(), 0, 0);
            setTimeout(() => {
                let useDetailedGrid = localStorage.getItem(gridKey(that));
                if (useDetailedGrid == "true" || (useDetailedGrid != "false" && shouldUseDetailedGridsInMobile() && isMobileDevice()))
                    openGridLineEditor(that);
            }, 500);
        }
    }

    setDataItemValues(item, rowIndex) {
        let that = this;
        let columns = that._kendoGrid().columns.flatMap(c => c.columns ? c.columns : c).filter(c => !isNullOrUndefined(c.field))
        for (let col of columns) {
            let columnMetadata = findFieldMetadata(col.id, that.metaData);
            if (!columnMetadata)
                continue;
            let value = that.owner.getFieldValue(col.id, rowIndex);
            if (!value)
                continue;
            let field = modelId(col.id);
            let numberCol = columnMetadata.fieldType === types.Decimal || columnMetadata.fieldType === types.Long || columnMetadata.fieldType === types.Integer;
            if (columnMetadata.fieldType === types.Reference || columnMetadata.fieldType === types.Genericreference) {
                if (value.id) {
                    item[field + "$dashedId"] = value.id;
                    item[field + "$nonDashedId"] = value.id.replaceAll("-", "");
                    item[field + "$normalId"] = "0x" + value.id;
                }
                if (value.code)
                    item[field + "$code"] = value.code;
                if (value.entityType)
                    item[field + "$entityType"] = value.entityType;
                if (value.altCode)
                    item[field + "$altCode"] = value.altCode;
                if (value.name1)
                    item[field + "$name1"] = value.name1;
                if (value.name2)
                    item[field + "$name2"] = value.name2;
            } else if (numberCol) {
                item[field + "$unformatted"] = value;
            }
            item[field] = value;
        }
    }

    _fixWidthsAccordingToHeader() {
        let that = this;
        if (!that._valueSet)
            return;
        if (that._widthesFixed)
            return;
        that._widthesFixed = true;
        let headers = that.findElement().find("span.n-c-header");
        let fieldsThatNeedChange = new Map();
        for (let i = 0; i < headers.length; i++) {
            let h = $(headers[i]);
            if (!h.parent().width())
                continue;
            let EXTRA_WIDTH = 35;
            if (h.width() + EXTRA_WIDTH > h.parent().width() && h.prop("id")) {
                fieldsThatNeedChange.set(h.prop("id"), h.width() + EXTRA_WIDTH);
            }
        }
        if (!fieldsThatNeedChange.size)
            return;
        let options = $.extend({}, that._kendoGrid().getOptions());
        let optionColumnsMap = new Map();
        traverseColumns(optionColumnsMap, options.columns);
        for (let [field, newWidth] of fieldsThatNeedChange.entries()) {
            let c = optionColumnsMap.get(field);
            if (c)
                c.width = newWidth;
        }
        setTimeout(() => {
            that._kendoGrid().setOptions(options);
        });
    }

    _autoFitColumns(allColumns) {
        if (allColumns)
            addWait();
        let that = this;
        let headers = that.findElement().find("span.n-c-header");
        for (let i = 0; i < headers.length; i++) {
            let h = $(headers[i]);
            if (allColumns || h.width() > h.parent().width())
                that._kendoGrid().autoFitColumn(h.prop("id"))
        }
        if (allColumns)
            removeWait();
    }

    setValue(value, colId, rowIndex) {
        let that = this;
        try {
            that.settingValue = true;
            that._valueSet = true;
            let grid = that._kendoGrid();
            if (!grid)
                return;
            if (colId === that.id || !colId) {
                grid.dataSource.read();
                return;
            }

            if (noRowIndex(rowIndex)) {
                for (let i = 0; i < grid.dataSource.data().length; i++) {
                    let dataItem = grid.dataSource.data()[i];
                    that.updateInDataItem(dataItem, colId, that.owner.getFieldValue(colId, i))
                }
            } else {
                let changedItem = grid.dataSource.data()[rowIndex];
                if (changedItem)
                    that.updateInDataItem(changedItem, colId, that.owner.getFieldValue(colId, rowIndex))
            }
        } finally {
            that.settingValue = false;
        }
    }

    /**
     *
     * @private
     * @return {kendo.ui.Grid}
     */
    _kendoGrid() {
        return this.findElement().data("kendoGrid");
    }

    /**
     *
     * @private
     * @return {kendo.ui.Grid}
     */
    kendoGrid() {
        return this._kendoGrid();
    }

    shouldAddBlurHandler() {
        return false;
    }

    updateInDataItem(dataItem, fieldId, fieldValue) {
        if (!dataItem)
            return;
        let that = this;
        let trimmedId = fieldId.substring(that.id.length + 1, fieldId.length);
        if (that.settingValue) {
            setFieldValue(dataItem, trimmedId, fieldValue);
            dataItemSetterCallback(trimmedId, that, dataItem, fieldValue);
            return;
        }
        dataItemSetterCallback(trimmedId, that, dataItem, fieldValue);
        let rowId = dataItem["id"];
        that.onColumnChanged(trimmedId, fieldValue, rowId);
    }

    onDataChanged(fieldId, fieldValue, options) {
        let that = this;
        that.updateInDataItem(options.model, fieldId, fieldValue);
        let grid = that._kendoGrid();
        let rowId = options.model["id"];
        let rowIndex = that._getRowIndex(rowId);
        if (that.popupEditor)
            that.popupEditor.updatePopupEditWidgetsValues(rowIndex);
    }

    onColumnChanged(trimmedId, value, rowId) {
        let that = this;
        let detail = that._getRow(rowId);
        setFieldValue(detail, trimmedId, value);
        let rowIndex = that._getRowIndex(rowId);
        let colId = that.id + "." + trimmedId;
        that.removeErrorMarkerAndTooltip(rowIndex, that.id + "." + trimmedId)
        performPostAction(that.owner, colId, value, rowIndex, that);

    }

    fetchExtraCriteria() {
        let that = this;
        let questionListWidget = that.owner;
        if (!questionListWidget instanceof QuestionListWidget)
            return that.extraCriteria;
        let questionFieldEditor = null;
        if (questionListWidget.owner && (questionListWidget.owner instanceof QuestionFieldsEditor))
            questionFieldEditor = questionListWidget.owner;
        return defaultCriteriaForFilterField(questionListWidget.questionField, that.entityType, valueCalculatorForQuestionField(questionFieldEditor));
    }

    _getRowIndex(rowId) {
        let that = this;
        if (!rowId) {
            let dataItem = that.currentDataItem();
            if (!dataItem)
                return -1;
            rowId = dataItem.get("id");
        }
        let details = that.owner.getFieldValue(that.id);
        for (let i = 0; i < details.length; i++) {
            if (details[i].id === rowId) {
                return i;
            }
        }
    }

    _getRow(rowId) {
        let details = this.owner.getFieldValue(this.id);
        for (let i = 0; i < details.length; i++) {
            if (details[i].id === rowId) {
                return details[i]
            }
        }
    }

    getPlaceExtraFieldFilterId() {
        return this.owner.getPlaceExtraFieldFilterId();
    }

    /**
     *
     * @param {namaTypes.EditScreenGrid} grid
     * @param {namaTypes.NaMaMetaData}
     */
    static hasColumns(grid, metaData, presenter) {
        for (let column of grid.columns) {
            let columnMetadata = findFieldMetadata(column.id, metaData)
            if (!columnMetadata)
                continue;
            if (!userCanViewField(presenter.entityType, column.id))
                continue;
            if (!isFeatureEnabled(columnMetadata.relatedToFeature))
                continue;
            return true;
        }
        return false;
    }

    updatePrevalidationState(state, objectIndex) {
        let that = this;
        if (objectIndex === -1) {
            let grid = this._kendoGrid();
            let data = grid.dataSource.data();
            let length = data && data.length ? data.length : 1;
            for (let i = 0; i < length; i++) {
                that.updatePrevalidationState(state, i);
            }
            return;
        }
        if (that.popupEditor) {
            that.popupEditor.updatePopupEditWidgetsState(state);
            return;
        }
        let cell = that.fetchCell(objectIndex, state.fieldId);
        if (!cell)
            return;
        if (state.state === "Disabled")
            cell.attr("readonly", true);
        else
            cell.removeAttr("readonly");
    }

    fetchCell(rowIndex, fieldId) {
        let grid = this._kendoGrid();
        let data = grid.dataSource.data();
        let dataItem = data[rowIndex];
        if (!dataItem)
            return;
        let row = grid.tbody.find("tr[data-uid=" + dataItem.uid + "]");
        let cell = row.find("td[nama-col='" + modelId(fieldId) + "']");
        return cell;
    }

    elementToHighlight() {
        return this.findElement().find(".k-grid-header");
    }

    async appendEmptyRows(rowsCount, insertAfterIndex, insertAtEnd, doNotIgnoreEmptyLine) {
        let that = this;
        that.addingEmptyLines = true;
        let grid = that._kendoGrid();
        let current = 0;
        let cb = () => {
            if (current >= rowsCount) {
                that.addingEmptyLines = false;
                return;
            }
            if (!busy()) {
                let newIndex = insertAfterIndex + current;
                if (newIndex > 0)
                    gridFocusCell(that, that._kendoGrid(), 1, newIndex - 1, null, 1);
                let firstRowCell = grid.tbody.find("tr:eq(" + newIndex + ") td:first");
                grid.current(firstRowCell);
                appendRow(grid, insertAtEnd, that, !doNotIgnoreEmptyLine);
                current++;
            }
            setTimeout(cb, 25);
        };
        setTimeout(cb, 25);
    }

    containsColumn(columnId) {
        let that = this;
        let columns = that.getColumns();
        if (columns) {
            for (let col of columns)
                if (col.id === columnId || that.genReferenceEntityTypeCol(columnId, col))
                    return true;
        }
        return false;
    }

    genReferenceEntityTypeCol(columnId, srcCol) {
        let that = this;
        if (srcCol.id + ".entityType" === columnId) {
            let columnMetadata = findFieldMetadata(srcCol.id, that.metaData);
            if (columnMetadata.fieldType === FieldType.Genericreference)
                return true;
        }
        return false;
    }

    isGenReferenceEntityTypeCol(columnId) {
        let that = this;
        let columns = that.getColumns();
        if (columns) {
            for (let col of columns) {
                if (that.genReferenceEntityTypeCol(columnId, col))
                    return true;
            }
        }
        return false;
    }

    isDeleteRowDisabled() {
        let that = this;
        let presenter = that.owner;
        return userCanNOTInsertOrDeleteLine(presenter.entityType, that.id, isInNewMode(presenter) ? ApplicableWhen.NewMode : ApplicableWhen.UpdateMode, GridAction.DeleteLine);

    }

    dispatchCanAppendOrDeleteRow() {
        let presenter = this.owner;
        return !presenter.isViewOnlyMode();
    }

    canDeleteRow() {
        let that = this;
        if (that.questionList)
            return true;
        let notEditableGrid = that.findElement().attr("readonlyGrid");
        if (notEditableGrid)
            return false;
        if (that.isDeleteRowDisabled())
            return false;
        if (!that.dispatchCanAppendOrDeleteRow())
            return false;
        return true;
    }

    canAppendRow() {
        let that = this;
        if (that.questionList)
            return true;
        let notEditableGrid = that.findElement().attr("readonlyGrid");
        if (notEditableGrid)
            return false;
        if (that.isAppendRowDisabled())
            return false;
        if (!that.dispatchCanAppendOrDeleteRow())
            return false;
        return true;
    }

    isLastLineEmpty() {
        let data = this._kendoGrid().dataSource.data();
        if (!data || !data.length)
            return false;
        let dataItem = data[data.length - 1];
        let realkeys = Object.keys(dataItem).removeAll(realLineKeys());
        return realkeys <= 0;
    }

    isAppendRowDisabled() {
        let that = this;
        let presenter = that.owner;
        return userCanNOTInsertOrDeleteLine(presenter.entityType, that.id, isInNewMode(presenter) ? ApplicableWhen.NewMode : ApplicableWhen.UpdateMode, GridAction.InsertLine);

    }

    isCopyRowDisabled() {
        let that = this;
        let presenter = that.owner;
        return userCanNOTCopyLine(presenter.entityType, that.id, isInNewMode(presenter) ? ApplicableWhen.NewMode : ApplicableWhen.UpdateMode);

    }

    setEnabled(enabled) {
        if (enabled === "Enabled" || enabled === true)
            this.findElement().removeAttr("readonlyGrid");
        else
            this.findElement().attr("readonlyGrid", true);
    }

    removeErrorMarkerAndTooltip(rowIndex, fieldId) {
        let that = this;
        if (noRowIndex(rowIndex) || !fieldId)
            return;
        let cell = that.fetchCell(rowIndex, fieldId);
        cell.removeClass("invalidCell");
        cell.removeClass("k-tooltip");
    }

    attachShortCutIcons() {
        let that = this;
        if (that.findElement().find("#shortCutBtns").length)
            return;
        let div = $(`<div id ="shortCutBtns"><button class="k-button" id = "addNewLine"  title="${translateId("addNewLine")}">
                <span class="k-icon k-i-add gridToolBarIcon"></span></button><button class="k-button" id = "copyLine" 
                title="${translateId("copyLine")}"><span class="k-icon k-i-copy gridToolBarIcon" ></span></button>
                <button class="k-button" id = "multiCopy" title="${translateId("multiCopy")}">
                <span class="k-icon k-i-aggregate-fields gridToolBarIcon" ></span></button>
                <button class="k-button" id = "deleteLine" title="${translateId("deleteLine")}"><span class="k-icon k-i-delete gridToolBarIcon" >
                </span></button><button class="k-button" id = "insertLine" title="${translateId("insertLine")}">
                <span class="k-icon k-i-arrow-parent gridToolBarIcon" ></span></button>
                <button class="k-button" id = "rowUp" title="${translateId("rowUp")}">
                <span class="k-icon k-i-arrow-up gridToolBarIcon" ></span></button>
                <button class="k-button" id = "rowDown" title="${translateId("rowDown")}">
                <span class="k-icon k-i-arrow-down gridToolBarIcon" ></span></button>
                <button class="k-button" id = "selectLines" title="${translateId("MultipleChoices")}">
                <span class="k-icon k-i-check-circle gridToolBarIcon" ></span></button>
                <button class="k-button" id = "editLine" title="${translateId("editLine")}">
                <span class="k-icon k-i-edit gridToolBarIcon" ></span></button>
                </div>`);
        let pager = that.findElement().find(".k-grid-pager");
        if (isMobileDevice()) {
            div.find("#addNewLine").remove();
            div.find("#copyLine").remove();
            div.find("#deleteLine").remove();
            div.find("#rowUp").remove();
            div.find("#rowDown").remove();
            pager.before(div);
            let gridHeight = that.findElement().height();
            that.findElement().closest(".k-pane-wrapper").height(gridHeight + div.height());
        } else {
            pager.append(div);
        }

    }

    afterAddingToGridAction(widget, options, trimmedFieldId, container) {
        if (container instanceof NamaGridLineEditor) {
            let colById = container.findColById(widget.id);
            let title = colById ? colById.title : colById.id;
            container.addWidget(widget);
            container.group.groupHandler.addWidget({
                id: widget.id,
                customFieldTitle: title
            }, {owner: {ownerId: this.entityType}}, null, {}, null, 1, widget);
        } else {
            widget.insideGrid = true;
            widget.render().appendTo(container);
            widget.afterAttach();
            widget.setValue(fieldValue(options.model, trimmedFieldId));
        }

    }

    allColumnsAreReadOnly(rowIndex) {
        let that = this;
        let columns = that._kendoGrid().columns.flatMap(c => c.columns ? c.columns : c).filter(c => c.id && !c.hidden && (!c.editable || (c.editable && c.editable() === true)))
        for (let c of columns) {
            let readOnlyCell = that.fetchCell(rowIndex, c.id).attr("readonly");
            if (readOnlyCell === undefined || readOnlyCell === false)
                return false;
        }
        return true;
    }

    currentDataItem() {
        let that = this;
        let current = that._kendoGrid().current();
        if (!current)
            return null;
        let grid = that._kendoGrid();
        let dataItem = grid.dataItem(current.parent());
        if (dataItem)
            return dataItem;
        if (that.popupEditor)
            return that.popupEditor.currentDataItem;
    }

    focusColumnInLastRow(focusFieldAfterAutoSave) {
        let that = this;
        let cells = that.findElement().find("td[fieldid='" + focusFieldAfterAutoSave + "']");
        if (!cells || !cells.length)
            return;
        gridFocusCell(that, that._kendoGrid(), $(cells[0]).index(), ":last");
    }
}

function traverseColumns(map, columns) {
    for (let column of columns) {
        if (column.columns && column.columns.length)
            traverseColumns(map, column.columns);
        else
            map.set(column.field, column);
    }
}

/**
 *
 * @param {ExtendedFieldMetaData|string} subField
 * @param {ExtendedFieldMetaData|string} detailField
 * @return {string}
 */
export function getTrimmedId(subField, detailField) {
    let subFieldId = subField.fieldId ? subField.fieldId : subField;
    let detailFieldId = detailField.fieldId ? detailField.fieldId : detailField;
    return subFieldId.substring(detailFieldId.length + 1);
}

export function modelId(fieldId) {
    return "$" + fieldId.replaceAll(".", "$")
}

export function singleAllowedValuesForEntityTypes(columnMetadata) {
    if (!columnMetadata)
        return false;
    if (!columnMetadata.allowedValues)
        return false;
    return columnMetadata.allowedValues.length === 1;
}

export function isColHidden(owner, fieldId, column) {
    if (getColHidden(owner, fieldId) === "true")
        return true;
    return column ? column.showInGridView === false : false;
}

export function noRowIndex(rowIndex) {
    return rowIndex === undefined || rowIndex === null || rowIndex === -1;
}